import React from "react";
import "./Pagination.css"; // Add CSS for styling

export default function CustomPagination({
  totalPages,
  currentPage,
  onPageChange,
}) {
  const maxVisibleButtons = 3;

  const getPageNumbers = () => {
    const pages = [];
    const start = Math.max(1, currentPage - Math.floor(maxVisibleButtons / 2));
    const end = Math.min(totalPages, start + maxVisibleButtons - 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const visiblePages = getPageNumbers();
  const shouldShowLastPage = !visiblePages.includes(totalPages);

  return (
    <div className="pagination">
      <button
        className="pagination-button-arrow"
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <img src="./images/icons/pagination-left.png" alt="arrow icon" />
      </button>
      <div className="pagination-inner-container">
        {visiblePages.map((page) => (
          <button
            key={page}
            className={`pagination-button ${
              page === currentPage ? "active" : ""
            }`}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </button>
        ))}
        {currentPage < totalPages - Math.floor(maxVisibleButtons / 2) && (
          <span>...</span>
        )}
        {shouldShowLastPage && (
          <button
            className={`pagination-button ${
              currentPage === totalPages ? "active" : ""
            }`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        )}
      </div>
      <button
        className="pagination-button-arrow"
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        <img src="./images/icons/pagination-right.png" alt="arrow icon" />
      </button>
    </div>
  );
}
